import { render, staticRenderFns } from "./tzproduct1.vue?vue&type=template&id=8058fa8a&scoped=true"
import script from "./tzproduct1.vue?vue&type=script&lang=js"
export * from "./tzproduct1.vue?vue&type=script&lang=js"
import style0 from "./tzproduct1.vue?vue&type=style&index=0&id=8058fa8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8058fa8a",
  null
  
)

export default component.exports